export const ANNOUNCEMENTS_CAROUSEL_SLIDE_DURATION = 15_000;
export const VALIDATE_ANNOUNCEMENT_INTERVAL = 60_000;
export const ANNOUNCEMENT_DESCRIPTION_LINES = 4;
